<section class="cumpleanos">
    <div class="container">
        <h1 class="section-tit1">{{tituloCumpleanos}}</h1>
        <div class="listado-cumpleanos" [ngClass]="{'con-banner': banner && banner.activo}">
            <neo-bloque-cumpleanos *ngFor="let paquete of paquetes" [paquete]="paquete"></neo-bloque-cumpleanos>
        </div>
    </div>
    <div class="sliderClientes galeria">
        <div class="block-cont container">
            <h2 class="section-tit2 isotipo-stroke" *ngIf="sliderClientes['titulo']" [innerHtml]="sliderClientes['titulo']"></h2>
            <neo-slider #sliderClientesCarousel *ngIf="sliderClientes['imagenes']" class="carousel" #carouselsliderClientes
            [slides]="sliderClientes['imagenes']" [id]="'galeria-slider'" [handlers]="false" [slidesPerView]="'auto'"
            [spaceBetween]="20" [loop]="true" [mostrarGaleria]="true"></neo-slider>
        </div>
    </div>
    <div class="container">
        <div class="banner-container" *ngIf="banner && banner.activo">
            <div class="banner banner-fixed">
                <div class="container">
                    <!-- BANNER PENDIENTE DE MAQUETACION  -->
                    <img class="banner-lg" *ngIf="banner.imagenHorizontal && banner.imagenHorizontal.rutaAbsoluta"
                    (click)="(banner.descripcion) ? verInformacionBanner(): return;" src="{{banner.imagenHorizontal.rutaAbsoluta}}"
                    alt="{{banner.imagenHorizontal.nombre}}" />
                    <img class="banner-xs" *ngIf="banner.imagenVertical && banner.imagenVertical.rutaAbsoluta"
                    (click)="(banner.descripcion) ? verInformacionBanner(): return;" src="{{banner.imagenVertical.rutaAbsoluta}}"
                    alt="{{banner.imagenVertical.nombre}}" />
                </div>
            </div>
        </div>
    </div>
</section>

<div class="bottom-cta" [ngClass]="{'con-banner': banner && banner.activo}">
    <neo-bottom-cta [color]="'negative'"></neo-bottom-cta>
</div>
<ng-template #dialogoInformacionBanner>
    <neo-acciones-dialog #accionDialogoInformacionBanner [dialogTittle]="'Más información'" [botonera]="[]">
        <p *ngIf="banner.descripcion">{{banner.descripcion}}</p>
    </neo-acciones-dialog>
</ng-template>